import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "performance"
    }}>{`Performance`}</h1>
    <p>{`If you want your add-on to become a key part of a user’s workflow, you must make sure it performs smoothly and efficiently.`}</p>
    <h2 {...{
      "id": "overview"
    }}>{`Overview`}</h2>
    <p>{`Your add-on must meet acceptable standards in terms of loading time, response time and utilization of resources. You should also bear in mind that a user’s experience may differ, based on factors such as their network connection.`}</p>
    <p>{`Below are a few things to consider before submitting for review.`}</p>
    <h2 {...{
      "id": "crashes"
    }}>{`Crashes`}</h2>
    <p>{`Your add-on must not cause any slowdowns or crashes on Adobe Express.`}</p>
    <h2 {...{
      "id": "system-resources"
    }}>{`System resources`}</h2>
    <p>{`You must ensure your add-on does not consume excessive system resources which may affect the performance of the user’s system, or Adobe Express itself. This includes resources such as CPU and memory.`}</p>
    <h2 {...{
      "id": "network-calls"
    }}>{`Network calls`}</h2>
    <p>{`Your add-on must not make an excessive amount of network calls. You can monitor this by noting the number of network calls made over a certain period, and comparing it to a predetermined threshold.`}</p>
    <h2 {...{
      "id": "network-efficiency"
    }}>{`Network efficiency`}</h2>
    <p>{`Make sure your add-on is network efficient and does not have any performance issues. You can do this by noting the time it takes to complete a network call and how much data is transferred.`}</p>
    <h2 {...{
      "id": "network-usage"
    }}>{`Network usage`}</h2>
    <p>{`We recommend using network monitoring tools to identify any unexpected or excessive network activity caused by the add-on.`}</p>
    <h2 {...{
      "id": "network-security"
    }}>{`Network security`}</h2>
    <p>{`Your add-on must not pose any security risks, and network calls must be secure. We require that add-ons use secure protocols, encrypt sensitive data, and implement appropriate authentication and authorization mechanisms.`}</p>
    <h2 {...{
      "id": "network-call-logs"
    }}>{`Network call logs`}</h2>
    <p>{`Review your network call logs to identify any anomalies or notable patterns in network usage. This helps you identify any issues related to network calls.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      